const hotelDayPassesByLocation = [
  {
    title: 'Top Locations',
    allUrl: '/browse-hotels',
    data: [
      { name: 'Miami, FL', url: '/s/us/fl/miami/hotel-day-passes' },
      { name: 'Phoenix, AZ', url: '/s/us/az/phoenix/hotel-day-passes' },
      { name: 'Orlando, FL', url: '/s/us/fl/orlando/hotel-day-passes' },
      { name: 'Los Angeles, CA', url: '/s/us/ca/los-angeles/hotel-day-passes' },
      { name: 'Fort Lauderdale, FL', url: '/s/us/fl/fort-lauderdale/hotel-day-passes' },
      { name: 'San Diego, CA', url: '/s/us/ca/san-diego/hotel-day-passes' },
      { name: 'Austin, TX', url: '/s/us/tx/austin/hotel-day-passes' },
      { name: 'Palm Springs, CA', url: '/s/us/ca/palm-springs/hotel-day-passes' },
      { name: 'Dallas, TX', url: '/s/us/tx/dallas/hotel-day-passes' },
      { name: 'New York City, NY', url: '/s/us/ny/new-york/hotel-day-passes' },
      { name: 'San Juan, PR', url: '/s/pr/pr/san-juan/hotel-day-passes' },
      { name: 'Tampa, FL', url: '/s/us/fl/tampa/hotel-day-passes' },
      { name: 'Oahu, HI', url: '/s/us/hi/oahu/hotel-day-passes' },
      { name: 'Big Island, HI', url: '/s/us/hi/big-island/hotel-day-passes' },
      { name: 'Sonoma, CA', url: '/s/us/ca/sonoma/hotel-day-passes' },
      { name: 'Napa, CA', url: '/s/us/ca/napa/hotel-day-passes' },
      { name: 'Houston, TX', url: '/s/us/tx/houston/hotel-day-passes' },
      { name: 'Atlanta, GA', url: '/s/us/ga/atlanta/hotel-day-passes' },
      { name: 'Nashville, TN', url: '/s/us/tn/nashville/hotel-day-passes' },
      { name: 'Maui, HI', url: '/s/us/hi/maui/hotel-day-passes' },
      { name: 'San Antonio, TX', url: '/s/us/tx/san-antonio/hotel-day-passes' },
      { name: 'New Orleans, LA', url: '/s/us/la/new-orleans/hotel-day-passes' },
      { name: 'Tucson, AZ', url: '/s/us/az/tucson/hotel-day-passes' },
      { name: 'Washington, DC', url: '/s/us/dc/washington/hotel-day-passes' },
      { name: 'Fort Myers, FL', url: '/s/us/fl/fort-myers/hotel-day-passes' },
      { name: 'Nassau, BS', url: '/s/bs/bs--np/nassau/hotel-day-passes' },
      { name: 'Clearwater Beach, FL', url: '/s/us/fl/clearwater-beach/hotel-day-passes' },
      { name: 'San Francisco, CA', url: '/s/us/ca/san-francisco/hotel-day-passes' },
      { name: 'Las Vegas, NV', url: '/s/us/nv/las-vegas/hotel-day-passes' },
      { name: 'Chicago, IL', url: '/s/us/il/chicago/hotel-day-passes' },
      { name: 'West Palm Beach, FL', url: '/s/us/fl/west-palm-beach/hotel-day-passes' },
      { name: 'Santa Barbara, CA', url: '/s/us/ca/santa-barbara/hotel-day-passes' },
      { name: 'Kauai, HI', url: '/s/us/hi/kauai/hotel-day-passes' },
      { name: 'Huntington Beach, CA', url: '/s/us/ca/huntington-beach/hotel-day-passes' },
      { name: 'Newport Beach, CA', url: '/s/us/ca/newport-beach/hotel-day-passes' },
      { name: 'Anaheim, CA', url: '/s/us/ca/anaheim/hotel-day-passes' },
      { name: 'Fort Walton Beach, FL', url: '/s/us/fl/fort-walton-beach/hotel-day-passes' },
      { name: 'Denver, CO', url: '/s/us/co/denver/hotel-day-passes' },
      { name: 'Boston, MA', url: '/s/us/ma/boston/hotel-day-passes' },
      { name: 'Key Largo, FL', url: '/s/us/fl/key-largo/hotel-day-passes' },
      { name: 'South Padre Island, TX', url: '/s/us/tx/south-padre-island/hotel-day-passes' },
      { name: 'Key West, FL', url: '/s/us/fl/key-west/hotel-day-passes' },
      { name: 'Pensacola Beach, FL', url: '/s/us/fl/pensacola-beach/hotel-day-passes' },
      { name: 'Naples, FL', url: '/s/us/fl/naples/hotel-day-passes' },
      { name: 'Sarasota, FL', url: '/s/us/fl/sarasota/hotel-day-passes' },
      { name: 'Daytona Beach, FL', url: '/s/us/fl/daytona-beach/hotel-day-passes' },
      { name: 'Puerto Vallarta, MX', url: '/s/mx/mx--jal/puerto-vallarta/hotel-day-passes' },
      { name: 'Panama City Beach, FL', url: '/s/us/fl/panama-city-beach/hotel-day-passes' },
      { name: 'Cancún, MX', url: '/s/mx/mx/canc%C3%BAn/hotel-day-passes' },
      { name: 'Philadelphia, PA', url: '/s/us/pa/philadelphia/hotel-day-passes' },
    ],
  },
  {
    title: 'Top Hotels',
    allUrl: '/browse-hotels',
    data: [
      { name: 'Hilton Orlando', url: '/hotels/hilton-orlando' },
      { name: 'Arizona Grand Resort & Spa', url: '/hotels/arizona-grand-resort-and-spa' },
      { name: 'Hilton Waikoloa Village', url: '/hotels/hilton-waikoloa-village' },
      { name: 'Eden Roc Miami Beach', url: '/hotels/eden-roc-miami-beach' },
      { name: 'Fairmont Scottsdale Princess', url: '/hotels/fairmont-scottsdale-princess' },
      {
        name: 'Omni Orlando Resort at ChampionsGate',
        url: '/hotels/omni-orlando-resort-championsgate',
      },
      { name: 'Fairmont El San Juan Hotel', url: '/hotels/fairmont-el-san-juan' },
      { name: 'Hilton Phoenix Resort at the Peak', url: '/hotels/hilton-phoenix-resort-peak' },
      {
        name: 'Trump International Beach Resort Miami',
        url: '/hotels/trump-international-beach-resort-miami',
      },
      { name: 'Kimpton Surfcomber Hotel', url: '/hotels/kimpton-surfcomber-hotel' },
      {
        name: 'JW Marriott Phoenix Desert Ridge Resort & Spa',
        url: '/hotels/jw-marriott-phoenix-desert-ridge-resort-and-spa',
      },
      { name: 'Marriott Marquis Houston', url: '/hotels/marriott-marquis-houston' },
      {
        name: 'Margaritaville Hollywood Beach Resort',
        url: '/hotels/margaritaville-hollywood-beach-resort',
      },
      { name: 'The Savoy Hotel & Beach Club', url: '/hotels/the-savoy-hotel-and-beach-club' },
      {
        name: 'Hyatt Regency Coconut Point Resort and Spa',
        url: '/hotels/hyatt-regency-coconut-point-resort-and-spa',
      },
      {
        name: 'The Westin Kierland Resort & Spa',
        url: '/hotels/the-westin-kierland-resort-and-spa',
      },
      {
        name: 'Margaritaville Beach Resort Fort Myers Beach',
        url: '/hotels/margaritaville-beach-resort-fort-myers-beach',
      },
      { name: 'TWA Hotel', url: '/hotels/twa-hotel' },
      { name: 'Grand Hyatt Kauai Resort & Spa', url: '/hotels/grand-hyatt-kauai-resort-and-spa' },
      { name: 'Hotel Riu Plaza Miami Beach', url: '/hotels/hotel-riu-plaza-miami-beach' },
      { name: 'Town and Country San Diego', url: '/hotels/town-and-country-san-diego' },
      { name: 'Andaz West Hollywood', url: '/hotels/andaz-west-hollywood' },
      { name: 'Omni Barton Creek Resort & Spa', url: '/hotels/omni-barton-creek-resort-and-spa' },
      {
        name: 'Tidal Cove Waterpark at JW Marriott Miami Turnberry Resort & Spa',
        url: '/hotels/tidal-cove-waterpark',
      },
      { name: 'Grand Hyatt Scottsdale Resort', url: '/hotels/grand-hyatt-scottsdale-resort' },
    ],
  },
  {
    title: 'Top Pools',
    allUrl: '/browse-pools',
    data: [
      { name: 'Pools in Phoenix', url: '/s/us/az/phoenix/pool' },
      { name: 'Pools in Miami', url: '/s/us/fl/miami/pool' },
      { name: 'Pools in Los Angeles', url: '/s/us/ca/los-angeles/pool' },
      { name: 'Pools in Orlando', url: '/s/us/fl/orlando/pool' },
      { name: 'Pools in San Diego', url: '/s/us/ca/san-diego/pool' },
      { name: 'Pools in Austin', url: '/s/us/tx/austin/pool' },
      { name: 'Pools in Fort Lauderdale', url: '/s/us/fl/fort-lauderdale/pool' },
      { name: 'Pools in Las Vegas', url: '/s/us/nv/las-vegas/pool' },
      { name: 'Pools in Palm Springs', url: '/s/us/ca/palm-springs/pool' },
      { name: 'Pools in New York', url: '/s/us/ny/new-york/pool' },
      { name: 'Pools in San Juan', url: '/s/pr/pr/san-juan/pool' },
      { name: 'Pools in Dallas', url: '/s/us/tx/dallas/pool' },
      { name: 'Pools in Tampa', url: '/s/us/fl/tampa/pool' },
      { name: 'Pools in Big Island', url: '/s/us/hi/big-island/pool' },
      { name: 'Pools in Houston', url: '/s/us/tx/houston/pool' },
      { name: 'Pools in Oahu', url: '/s/us/hi/oahu/pool' },
      { name: 'Pools in Nashville', url: '/s/us/tn/nashville/pool' },
      { name: 'Pools in Maui', url: '/s/us/hi/maui/pool' },
      { name: 'Pools in Napa', url: '/s/us/ca/napa/pool' },
      { name: 'Pools in Sonoma', url: '/s/us/ca/sonoma/pool' },
      { name: 'Pools in New Orleans', url: '/s/us/la/new-orleans/pool' },
      { name: 'Pools in San Antonio', url: '/s/us/tx/san-antonio/pool' },
      { name: 'Pools in Atlanta', url: '/s/us/ga/atlanta/pool' },
      { name: 'Pools in Fort Myers', url: '/s/us/fl/fort-myers/pool' },
      { name: 'Pools in Tucson', url: '/s/us/az/tucson/pool' },
    ],
  },
  {
    title: 'Top Spas',
    allUrl: '/browse-spas',
    data: [
      { name: 'Spas in Miami', url: '/s/us/fl/miami/spa' },
      { name: 'Spas in Phoenix', url: '/s/us/az/phoenix/spa' },
      { name: 'Spas in Austin', url: '/s/us/tx/austin/spa' },
      { name: 'Spas in San Diego', url: '/s/us/ca/san-diego/spa' },
      { name: 'Spas in Palm Springs', url: '/s/us/ca/palm-springs/spa' },
      { name: 'Spas in Sonoma', url: '/s/us/ca/sonoma/spa' },
      { name: 'Spas in Washington, DC', url: '/s/us/dc/washington/spa' },
      { name: 'Spas in Fort Lauderdale', url: '/s/us/fl/fort-lauderdale/spa' },
      { name: 'Spas in Atlanta', url: '/s/us/ga/atlanta/spa' },
      { name: 'Spas in Napa', url: '/s/us/ca/napa/spa' },
      { name: 'Spas in Houston', url: '/s/us/tx/houston/spa' },
      { name: 'Spas in Tucson', url: '/s/us/az/tucson/spa' },
      { name: 'Spas in New York City', url: '/s/us/ny/new-york/spa' },
      { name: 'Spas in West Palm Beach', url: '/s/us/fl/west-palm-beach/spa' },
      { name: 'Spas in Los Angeles', url: '/s/us/ca/los-angeles/spa' },
      { name: 'Spas in Las Vegas', url: '/s/us/nv/las-vegas/spa' },
      { name: 'Spas in Chicago', url: '/s/us/il/chicago/spa' },
      { name: 'Spas in Orlando', url: '/s/us/fl/orlando/spa' },
      { name: 'Spas in San Antonio', url: '/s/us/tx/san-antonio/spa' },
      { name: 'Spas in Santa Barbara', url: '/s/us/ca/santa-barbara/spa' },
      { name: 'Spas in Huntington Beach', url: '/s/us/ca/huntington-beach/spa' },
      { name: 'Spas in Newport Beach', url: '/s/us/ca/newport-beach/spa' },
      { name: 'Spas in Kauai', url: '/s/us/hi/kauai/spa' },
      { name: 'Spas in San Juan', url: '/s/pr/pr/san-juan/spa' },
      { name: 'Spas in Nashville', url: '/s/us/tn/nashville/spa' },
    ],
  },
  {
    title: 'Top Day Rooms',
    allUrl: '/browse-day-rooms',
    data: [
      { name: 'Day Rooms in Fort Lauderdale', url: '/s/us/fl/fort-lauderdale/day-room' },
      { name: 'Day Rooms in Miami', url: '/s/us/fl/miami/day-room' },
      { name: 'Day Rooms in Orlando', url: '/s/us/fl/orlando/day-room' },
      { name: 'Day Rooms in Dallas', url: '/s/us/tx/dallas/day-room' },
      { name: 'Day Rooms in Oahu', url: '/s/us/hi/oahu/day-room' },
      { name: 'Day Rooms in Kauai', url: '/s/us/hi/kauai/day-room' },
      { name: 'Day Rooms in Los Angeles', url: '/s/us/ca/los-angeles/day-room' },
      { name: 'Day Rooms in Washington, DC', url: '/s/us/dc/washington/day-room' },
      { name: 'Day Rooms in Atlanta', url: '/s/us/ga/atlanta/day-room' },
      { name: 'Day Rooms in San Francisco', url: '/s/us/ca/san-francisco/day-room' },
      { name: 'Day Rooms in Tampa', url: '/s/us/fl/tampa/day-room' },
      { name: 'Day Rooms in San Diego', url: '/s/us/ca/san-diego/day-room' },
      { name: 'Day Rooms in San Juan', url: '/s/pr/pr/san-juan/day-room' },
      { name: 'Day Rooms in Phoenix', url: '/s/us/az/phoenix/day-room' },
      { name: 'Day Rooms in Maui', url: '/s/us/hi/maui/day-room' },
      { name: 'Day Rooms in Big Island', url: '/s/us/hi/big-island/day-room' },
      { name: 'Day Rooms in West Palm Beach', url: '/s/us/fl/west-palm-beach/day-room' },
      { name: 'Day Rooms in Fort Walton Beach', url: '/s/us/fl/fort-walton-beach/day-room' },
      { name: 'Day Rooms in Houston', url: '/s/us/tx/houston/day-room' },
      { name: 'Day Rooms in Austin', url: '/s/us/tx/austin/day-room' },
      { name: 'Day Rooms in Palm Springs', url: '/s/us/ca/palm-springs/day-room' },
      { name: 'Day Rooms in Chicago', url: '/s/us/il/chicago/day-room' },
      { name: 'Day Rooms in New York', url: '/s/us/ny/new-york/day-room' },
      { name: 'Day Rooms in Nassau', url: '/s/bs/bs--np/nassau/day-room' },
      { name: 'Day Rooms in Denver', url: '/s/us/co/denver/day-room' },
    ],
  },
];

export default hotelDayPassesByLocation;
